// 定数定義

// サービス種別
const SERVICE_TYPE_ALL = '00'         // 全て
const SERVICE_TYPE_DCMPAY = '01'      // d払い等決済サービス
const SERVICE_TYPE_WALLET = '02'      // d払い残高(旧ウォレット機能)
const SERVICE_TYPE_ONLINESHOP = '03'  // オンラインショップ
const SERVICE_TYPE_AHAMO = '04'       // ahamo
const SERVICE_TYPE_DCMPAY_TOUCH = '05' // d払いタッチ
const SERVICE_TYPE_DCMPAY_GIFT = '06' // d払いギフト

// ログインユーザ権限
const USER_AUTHORITY_ADMIN = '01'     // 管理者
const USER_AUTHORITY_OPERATOR = '02'  // 運営者
const USER_AUTHORITY_AGENCY = '03'    // 代行者
// 一覧種別
const LISTTYPE_ENQUIRY = '01'         // 問い合わせ一覧
const LISTTYPE_SETTLEMENT = '02'      // 決済一覧
// メインステータス
const STATUS_NEWENTRY = '000'         // 新規受付
const STATUS_WS_PROGRESS = '001'      // 主管部調査中
const STATUS_SD_REQUEST = '002'       // SD部依頼中
const STATUS_SD_PROGRESS = '003'      // SD部調査中
const STATUS_SD_COMPLETE = '004'      // SD部調査完了
const STATUS_REPAIR_JUDGE = '005'     // 補償判断中
const STATUS_REPAIR_OK = '006'        // 補償OK, サービス種別がd払いの場合：要補正（口座返還）
const STATUS_REPAIR_NG = '007'        // 補償NG
const STATUS_REPAIR_MIX = '008'       // 補償OK(一部NGあり)
const STATUS_COMPLETE_DOC = '009'       // 補償可否案内（文書発送）
const STATUS_COMPLETE_TEL = '010'       // 補償可否案内（架電）
const STATUS_CORRECTION_POINT = '011'             // 要補正（ポイント補正）
const STATUS_CORRECTION_AMOUNT = '012'            // 要補正（請求額訂正）, サービス種別がd払いの場合：請求額訂正済
const STATUS_CORRECTION_CC_CANCEL = '013'         // 要補正（クレカ取消）
const STATUS_CORRECTION_COMPLETE = '014'          // 補正完了
const STATUS_INVESTIGATION_WITHDRAWN = '015'      // 調査取下げ
const STATUS_DECLARATION = '016'              // 申告書対応
const STATUS_DECLARATION_RECEIPT = '017'      // 申告書受領
const STATUS_CORRECTION_MIXTURE = '018'       // 要補正（混合）
const STATUS_COMPLETE_OK = '019'              // 対応完了（補償OK）
const STATUS_COMPLETE_NG = '020'              // 対応完了（補償NG）
const STATUS_PREVIOUS = '021'                 // 過去分申告
const STATUS_TEST = '022'                     // テスト申告
const STATUS_NO_INVESTIGATION = '023'         // 未調査
const STATUS_REQUIRE_DATA_EXTRACTION = '024'  // 要データ抽出
const STATUS_CORRECTION_PLAN =  '025'   // 請求額訂正予定
// サブステータス
const SUBSTATUS_NONE = '000'                              // 未定
const SUBSTATUS_PHISHING = '001'                          // フィッシング
const SUBSTATUS_LIST_ATTACK = '002'                       // リスト攻撃
const SUBSTATUS_MALWARE = '003'                           // マルウェア
const SUBSTATUS_DISCARDED_ACCOUNTS = '004'                // 捨てアカ決済
const SUBSTATUS_HIJACKING_MAILACCOUNTS = '005'            // メールアカウント乗っ取り
const SUBSTATUS_CANCEL_INVEST = '006'                     // 調査取下げ
const SUBSTATUS_CANNOT_JUDGE = '007'                      // 判定不可
const SUBSTATUS_CANNOT_INVEST = '008'                     // 調査不可
const SUBSTATUS_THIRD_PARTY_ACCESS_FOREIGNERS = '009'     // 第三者アクセス（特定外国人不正案件）
const SUBSTATUS_THIRD_PARTY_ACCESS = '010'                // 第三者アクセス
const SUBSTATUS_PERSONALUSE = '011'                       // 本人利用
const SUBSTATUS_PARTIAL_PERSONALUSE = '012'               // 一部本人利用（複数種別あり）
// 決済手段（支払方法）
const SETTLEMENT_MEANS_TOTALING = '00'      // 合算
const SETTLEMENT_MEANS_DCMWALLET = '02'     // ｄ払い残高
const SETTLEMENT_MEANS_CREDIT = '08'        // クレジット払い
const SETTLEMENT_MEANS_DCARD = '09'         // dカード払い
const SETTLEMENT_MEANS_CONVENIENCE = '13'   // コンビニ払い
const SETTLEMENT_MEANS_CASHON = '15'        // 代引き
// 課金種別
const BILLING_METHOD_EACHTIME = '01'      // 都度決済
const BILLING_METHOD_PERIODICALLY = '02'  // 定期決済
const BILLING_METHOD_ANYTIME = '03'       // 随時決済
// メール承認ステータス
const ENDUSER_MAIL_STATUS_NONE = ''             // メール承認依頼前
const ENDUSER_MAIL_STATUS_APPROVAL_WAIT = '001' // メール承認待ち
const ENDUSER_MAIL_STATUS_APPROVED = '002'  // メール承認済
// メール送信ステータス
const ENDUSER_MAIL_SEND_STATUS_DEFAULT = '001'             // 申告時メール送信前
const ENDUSER_MAIL_SEND_STATUS_ENQUIRY_SEND_SUCCESS = '002' // 申告時メール送信成功
const ENDUSER_MAIL_SEND_STATUS_ENQUIRY_SEND_ERROR = '003'  // 申告時メール送信失敗
const ENDUSER_MAIL_SEND_STATUS_ENQUIRY_SEND_RETRY = '004'  // 申告時メール送信リトライ中
const ENDUSER_MAIL_SEND_STATUS_COMPLETE_SEND_SUCCESS = '005'  // 調査完了メール送信成功
const ENDUSER_MAIL_SEND_STATUS_COMPLETE_SEND_ERROR = '006'  // 調査完了メール送信失敗
const ENDUSER_MAIL_SEND_STATUS_COMPLETE_SEND_RETRY = '007'  // 調査完了メール送信リトライ中
const ENDUSER_MAIL_SEND_STATUS_COMPLETE_CANCEL_SUCCESS = "008"      // 申告取り下げメール送信成功
const ENDUSER_MAIL_SEND_STATUS_COMPLETE_CANCEL_ERROR = "009"      // 申告取り下げメール送信失敗
const ENDUSER_MAIL_SEND_STATUS_COMPLETE_CANCEL_RETRY = "010"      // 申告取り下げメール送信リトライ中
// 取引区分(WALLET)
const WALLET_TRADING_CLASS_001 = '010'    // ペイジー入金
const WALLET_TRADING_CLASS_002 = '011'    // 口座間送金入金
const WALLET_TRADING_CLASS_003 = '012'    // 口座間送金キャンセル入金
const WALLET_TRADING_CLASS_004 = '013'    // 口座間送金拒否入金
const WALLET_TRADING_CLASS_005 = '014'    // 送金組戻入金
const WALLET_TRADING_CLASS_006 = '016'    // 振込不能入金
const WALLET_TRADING_CLASS_007 = '017'    // 海外送金組戻入金
const WALLET_TRADING_CLASS_008 = '020'    // ペイジー入金二重収納
const WALLET_TRADING_CLASS_009 = '021'    // 入金取消後ペイジー入金
const WALLET_TRADING_CLASS_010 = '023'    // コンビニ入金
const WALLET_TRADING_CLASS_011 = '024'    // ケータイ払い決済取消入金
const WALLET_TRADING_CLASS_012 = '025'    // ケータイ払い決済期限切れ入金
const WALLET_TRADING_CLASS_013 = '026'    // ケータイ払い決済返金入金
const WALLET_TRADING_CLASS_014 = '027'    // 返金先口座入金
const WALLET_TRADING_CLASS_015 = '028'    // ｄジョブ報酬額＿入金（無料）
const WALLET_TRADING_CLASS_016 = '029'    // ｄジョブ報酬額＿入金（有料）
const WALLET_TRADING_CLASS_017 = '031'    // プリペイド決済オーソリ返品入金
const WALLET_TRADING_CLASS_018 = '032'    // プリペイド決済障害返品入金
const WALLET_TRADING_CLASS_019 = '033'    // プリペイド決済減額入金
const WALLET_TRADING_CLASS_020 = '034'    // プリペイド決済返品入金
const WALLET_TRADING_CLASS_021 = '036'    // プリペイド決済補正入金(利用金額返金）
const WALLET_TRADING_CLASS_022 = '037'    // プリペイド決済補正入金(発行手数料返金）
const WALLET_TRADING_CLASS_023 = '038'    // プリペイド決済補正入金(通信障害返金）
const WALLET_TRADING_CLASS_024 = '039'    // プリペイド決済補正入金(その他）
const WALLET_TRADING_CLASS_025 = '03A'    // プリペイド自動入金
const WALLET_TRADING_CLASS_026 = '050'    // モバチェ充当出金
const WALLET_TRADING_CLASS_027 = '051'    // 銀行口座振込出金
const WALLET_TRADING_CLASS_028 = '052'    // 口座間送金出金
const WALLET_TRADING_CLASS_029 = '053'    // 送金組戻出金
const WALLET_TRADING_CLASS_030 = '061'    // コンビニ入金取消出金
const WALLET_TRADING_CLASS_031 = '062'    // ケータイ払い出金
const WALLET_TRADING_CLASS_032 = '063'    // ケータイ払い決済増額出金
const WALLET_TRADING_CLASS_033 = '064'    // 返金元口座出金
const WALLET_TRADING_CLASS_034 = '065'    // 銀行口座振込出金（振込無料）
const WALLET_TRADING_CLASS_035 = '067'    // もどきGrp異動解約＿出金
const WALLET_TRADING_CLASS_036 = '070'    // 海外送金出金
const WALLET_TRADING_CLASS_037 = '072'    // プリペイド決済カード発行出金
const WALLET_TRADING_CLASS_038 = '073'    // プリペイド決済オーソリ出金
const WALLET_TRADING_CLASS_039 = '074'    // プリペイド決済増額出金
const WALLET_TRADING_CLASS_040 = '075'    // プリペイド決済障害取消出金
const WALLET_TRADING_CLASS_041 = '076'    // プリペイド決済補正出金(残高不足）
const WALLET_TRADING_CLASS_042 = '077'    // プリペイド決済補正出金(その他）
const WALLET_TRADING_CLASS_043 = '0A0'    // 返金出金（回線無料）
const WALLET_TRADING_CLASS_044 = '0A1'    // 返金出金（回線有料）
const WALLET_TRADING_CLASS_045 = '0A2'    // 返金出金（CF無料）
const WALLET_TRADING_CLASS_046 = '0A3'    // 返金出金（CF有料）
const WALLET_TRADING_CLASS_047 = '0A4'    // 不能金額入金（回線）
const WALLET_TRADING_CLASS_048 = '0A5'    // 不能金額入金（CF）
const WALLET_TRADING_CLASS_049 = '0A6'    // 不能手数料入金（回線）
const WALLET_TRADING_CLASS_050 = '0A7'    // 不能手数料入金（CF）
const WALLET_TRADING_CLASS_051 = '0B0'    // 報酬額＿出金
const WALLET_TRADING_CLASS_052 = '0B1'    // 報酬額＿入金
const WALLET_TRADING_CLASS_053 = '0B2'    // システム利用料＿出金
const WALLET_TRADING_CLASS_054 = '0B3'    // システム利用料＿入金
const WALLET_TRADING_CLASS_055 = '0B4'    // ポイント報酬額＿出金
const WALLET_TRADING_CLASS_056 = '0B5'    // ポイント報酬額＿入金
const WALLET_TRADING_CLASS_057 = '0B6'    // クライアント口座＿出金
const WALLET_TRADING_CLASS_058 = '0B7'    // クライアント口座＿入金
const WALLET_TRADING_CLASS_059 = '0B8'    // 払い出し＿出金
const WALLET_TRADING_CLASS_060 = '0B9'    // 払い出し＿入金
const WALLET_TRADING_CLASS_061 = '0BA'    // 払い出し不能＿出金
const WALLET_TRADING_CLASS_062 = '0BB'    // 払い出し不能＿入金
const WALLET_TRADING_CLASS_063 = '0BC'    // 銀行連携＿出金
const WALLET_TRADING_CLASS_064 = '0BD'    // 銀行連携＿入金
const WALLET_TRADING_CLASS_065 = '0BE'    // 支払用口座＿出金
const WALLET_TRADING_CLASS_066 = '0BF'    // 支払用口座＿入金
const WALLET_TRADING_CLASS_067 = '0BG'    // クライアント返金＿出金
const WALLET_TRADING_CLASS_068 = '0BH'    // クライアント返金＿入金
const WALLET_TRADING_CLASS_069 = '0BI'    // クライアント繰越＿出金
const WALLET_TRADING_CLASS_070 = '0BJ'    // クライアント繰越＿入金
const WALLET_TRADING_CLASS_071 = '0BK'    // 入金用口座＿出金
const WALLET_TRADING_CLASS_072 = '0BL'    // 入金用口座＿入金
const WALLET_TRADING_CLASS_073 = '0BM'    // クライアント拒否＿出金
const WALLET_TRADING_CLASS_074 = '0BN'    // クライアント拒否＿入金
const WALLET_TRADING_CLASS_075 = '0C0'    // 報酬予定額＿入金
const WALLET_TRADING_CLASS_076 = '0C2'    // 報酬予定額＿出金
const WALLET_TRADING_CLASS_077 = '0C3'    // 収入化＿出金
const WALLET_TRADING_CLASS_078 = '0C4'    // 報酬額＿入金（補正）
const WALLET_TRADING_CLASS_079 = '0C5'    // 報酬額＿出金（補正）
const WALLET_TRADING_CLASS_080 = '0C6'    // ポイント化＿出金
const WALLET_TRADING_CLASS_081 = '0C7'    // 報酬額＿出金(雑収)
const WALLET_TRADING_CLASS_082 = '0C8'    // 解約返金＿入金（補正）
const WALLET_TRADING_CLASS_083 = '02A'    // ｄカーＳ使用料入金(無料)
const WALLET_TRADING_CLASS_084 = '02B'    // ｄカーＳ使用料入金(有料)
const WALLET_TRADING_CLASS_085 = '02C'    // 障害取消入金
const WALLET_TRADING_CLASS_086 = '0W0'    // 口座間送金出金_D
const WALLET_TRADING_CLASS_087 = '0W1'    // 口座間送金入金_W
const WALLET_TRADING_CLASS_088 = '0W2'    // ペイジー入金_W
const WALLET_TRADING_CLASS_089 = '0W3'    // ペイジー入金二重収納_W
const WALLET_TRADING_CLASS_090 = '0W4'    // 入金取消後ペイジー入金_W
const WALLET_TRADING_CLASS_091 = '0W6'    // コンビニ入金_W
const WALLET_TRADING_CLASS_092 = '0W7'    // ケータイ払い出金_W
const WALLET_TRADING_CLASS_093 = '0W8'    // 決済取消入金_W
const WALLET_TRADING_CLASS_094 = '0W9'    // 決済期限切れ入金_W
const WALLET_TRADING_CLASS_095 = '0WA'    // 決済返金入金_W
const WALLET_TRADING_CLASS_096 = '0WB'    // 決済増額出金_W
const WALLET_TRADING_CLASS_097 = '0WC'    // 銀行連携＿出金_D
const WALLET_TRADING_CLASS_098 = '0WD'    // 銀行連携＿入金_W
const WALLET_TRADING_CLASS_099 = '0WE'    // ATM預入＿出金（法人）_D
const WALLET_TRADING_CLASS_100 = '0WF'    // ATM預入＿入金（個人）_W
const WALLET_TRADING_CLASS_101 = '0WG'    // 異動解約出金(雑収)_W
const WALLET_TRADING_CLASS_102 = '0WH'    // 昇格ウォレット出金_W
const WALLET_TRADING_CLASS_103 = '0WJ'    // 昇格ｄ払い残高入金_D
const WALLET_TRADING_CLASS_104 = '0WK'    // 失効出金(雑収)_W
const WALLET_TRADING_CLASS_105 = '0WL'    // 口座引落し＿入金_D
const WALLET_TRADING_CLASS_106 = '0WM'    // 口座引落し＿入金_W
const WALLET_TRADING_CLASS_107 = '0WN'    // CF異動解約＿出金_D
const WALLET_TRADING_CLASS_108 = '0WP'    // 送金組戻入金_W
const WALLET_TRADING_CLASS_109 = '0WQ'    // 送金組戻出金_W
const WALLET_TRADING_CLASS_110 = '0WR'    // 口座間送金出金（無料）_D
const WALLET_TRADING_CLASS_111 = '0WS'    // 口座間送金入金（無料）_W
const WALLET_TRADING_CLASS_112 = '0WT'    // 障害取消入金_W
const WALLET_TRADING_CLASS_113 = '100'    // 手数料課金なし
const WALLET_TRADING_CLASS_114 = '110'    // 送り手負担送金利用料
const WALLET_TRADING_CLASS_115 = '111'    // 受け手負担送金利用料
const WALLET_TRADING_CLASS_116 = '113'    // 海外送金手数料
const WALLET_TRADING_CLASS_117 = '130'    // 銀行振込出金手数料
const WALLET_TRADING_CLASS_118 = '131'    // 振込不能手数料
const WALLET_TRADING_CLASS_119 = '150'    // 組戻出金手数料
const WALLET_TRADING_CLASS_120 = '151'    // 組戻入金手数料
const WALLET_TRADING_CLASS_121 = '156'    // 海外組戻手数料
const WALLET_TRADING_CLASS_122 = '1C0'    // dジョブ入金手数料
const WALLET_TRADING_CLASS_123 = '1C1'    // dジョブ出金手数料
const WALLET_TRADING_CLASS_124 = '0D0'    // 銀行ATM預入＿出金（法人）
const WALLET_TRADING_CLASS_125 = '0D1'    // 銀行ATM預入＿入金（個人）
const WALLET_TRADING_CLASS_126 = '0D2'    // 銀行ATM払出＿出金（個人）
const WALLET_TRADING_CLASS_127 = '0D3'    // 銀行ATM払出＿入金（法人）
const WALLET_TRADING_CLASS_128 = '0D4'    // 銀行ATM払出取消＿出金（法人）
const WALLET_TRADING_CLASS_129 = '0D5'    // 銀行ATM払出取消＿入金（個人）
const WALLET_TRADING_CLASS_130 = '133'    // 銀行ATM払出手数料
const WALLET_TRADING_CLASS_131 = '1W0'    // 送り手負担送金利用料_D
const WALLET_TRADING_CLASS_132 = '1W1'    // 受け手負担送金利用料_W
const WALLET_TRADING_CLASS_133 = '1W4'    // 組戻入金手数料_W
const WALLET_TRADING_CLASS_134 = '1W5'    // 組戻出金手数料_W
const WALLET_TRADING_CLASS_135 = '0E0'    // 投資預入＿出金（法人）
const WALLET_TRADING_CLASS_136 = '0E1'    // 投資預入＿入金（個人）
const WALLET_TRADING_CLASS_137 = '0E2'    // 投資払出＿出金（個人）
const WALLET_TRADING_CLASS_138 = '0E3'    // 投資払出＿入金（法人）
const WALLET_TRADING_CLASS_139 = '0E4'	 // 融資預入＿出金（法人）
const WALLET_TRADING_CLASS_140 = '0E5'	 // 融資預入＿入金（個人）
const WALLET_TRADING_CLASS_141 = '0E6'	 // 融資払出＿出金（個人）
const WALLET_TRADING_CLASS_142 = '0E7'	 // 融資払出＿入金（法人）
const WALLET_TRADING_CLASS_143 = '0E8'	 // 投資預入＿出金（法人）_D
const WALLET_TRADING_CLASS_144 = '0E9'	 // 投資預入＿入金（個人）_W
const WALLET_TRADING_CLASS_145 = '0EA'	 // 融資預入＿出金（法人）_D
const WALLET_TRADING_CLASS_146 = '0EB'	 // 融資預入＿入金（個人）_W
const WALLET_TRADING_CLASS_147 = '0F0'	 // 口座間送金出金(URL)
const WALLET_TRADING_CLASS_148 = '0F1'	 // 口座間送金入金(URL)
const WALLET_TRADING_CLASS_149 = '0F2'	 // 口座間送金出金_D(URL)
const WALLET_TRADING_CLASS_150 = '0F3'	 // 口座間送金入金_W(URL)
const WALLET_TRADING_CLASS_151 = '0F4'	 // 口座間送キャン入金(URL)
const WALLET_TRADING_CLASS_152 = '0F5'	 // 口座間送金拒否入金(URL)
const WALLET_TRADING_CLASS_153 = '0G0'	 // 口座引落し＿入金_C
const WALLET_TRADING_CLASS_154 = '0G1'	 // 銀行ATM預入＿入金（個人）_C
const WALLET_TRADING_CLASS_155 = '0G2'	 // コンビニ入金_C
const WALLET_TRADING_CLASS_156 = '0GA'	 // ケータイ払い出金_C
const WALLET_TRADING_CLASS_157 = '0GB'	 // 決済取消入金_C
const WALLET_TRADING_CLASS_158 = '0GC'	 // 決済期限切れ入金_C
const WALLET_TRADING_CLASS_159 = '0GD'	 // 決済返金入金_C
const WALLET_TRADING_CLASS_160 = '0GE'	 // 決済増額出金_C
const WALLET_TRADING_CLASS_161 = '0GF'	 // 障害取消入金_C
const WALLET_TRADING_CLASS_162 = '0GZ'	 // 補正入金_C
const WALLET_TRADING_CLASS_163 = '0GY'	 // 補正出金_C
const WALLET_TRADING_CLASS_164 = '1GZ'	 // 補正入金手数料_C
const WALLET_TRADING_CLASS_165 = '1GY'	 // 補正出金手数料_C
const WALLET_TRADING_CLASS_166 = '0GP'	 // 異動解約＿出金_C
const WALLET_TRADING_CLASS_167 = '059'	 // 銀行口座限度額超え出金
const WALLET_TRADING_CLASS_168 = '0D6'	 // 銀行ATM限度額超え出金
const WALLET_TRADING_CLASS_169 = '0D7'	 // 銀行ATM限度額超え入金
const WALLET_TRADING_CLASS_170 = '1G2'	 // コンビニ入金手数料_C
const WALLET_TRADING_CLASS_171 = '120'	 // ペイジー入金手数料
const WALLET_TRADING_CLASS_172 = '121'	 // コンビニ入金手数料
const WALLET_TRADING_CLASS_173 = '1W2'	 // ペイジー入金手数料_W
const WALLET_TRADING_CLASS_174 = '1W3'	 // コンビニ入金手数料_W
const WALLET_TRADING_CLASS_175 = '078'	 // 海外送金＿出金（法人）
const WALLET_TRADING_CLASS_176 = '079'	 // 海外送金＿出金（法人）_D
const WALLET_TRADING_CLASS_177 = '07A'	 // 海外送金＿出金（個人）
const WALLET_TRADING_CLASS_178 = '03B'	 // 海外送金＿入金（個人）
const WALLET_TRADING_CLASS_179 = '03C'	 // 海外送金＿入金（個人）_W
const WALLET_TRADING_CLASS_180 = '03D'	 // 海外送金＿入金（法人）
const WALLET_TRADING_CLASS_181 = '0WU'	 // ｄ払い残高チャージ_D
const WALLET_TRADING_CLASS_182 = '05B'	 // 外部チャージ仮登録出金
const WALLET_TRADING_CLASS_183 = '05C'	 // 外部チャージ本登録出金
const WALLET_TRADING_CLASS_184 = '01A'	 // 外部チャージ取消入金
const WALLET_TRADING_CLASS_185 = '01B'	 // 外部チャージ拒否入金
const WALLET_TRADING_CLASS_186 = '019'	 // 外部チャージ入金
const WALLET_TRADING_CLASS_187 = '01C'	 // 加盟店ウォレット入金
const WALLET_TRADING_CLASS_188 = '05D'	 // 加盟店ウォレット出金
const WALLET_TRADING_CLASS_189 = '05E'	 // 加盟店ウォレット振込出金
const WALLET_TRADING_CLASS_190 = '135'	 // 加盟店ウォレット振込手数料
const WALLET_TRADING_CLASS_191 = '0EC'	 // 新融資預入_出金（法人）
const WALLET_TRADING_CLASS_192 = '0ED'	 // 新融資預入_入金（個人）
const WALLET_TRADING_CLASS_193 = '0EE'	 // 新融資払出_出金（個人）
const WALLET_TRADING_CLASS_194 = '0EF'	 // 新融資払出_入金（法人）
const WALLET_TRADING_CLASS_195 = '0EG'	 // 新融資預入_出金（法人）D
const WALLET_TRADING_CLASS_196 = '0EH'	 // 新融資預入_入金（個人）W
const WALLET_TRADING_CLASS_197 = '07B'	 // 給与振込＿出金（法人）
const WALLET_TRADING_CLASS_198 = '07C'	 // 給与振込＿出金（法人）_D
const WALLET_TRADING_CLASS_199 = '07D'	 // 経費精算＿出金（法人）
const WALLET_TRADING_CLASS_200 = '07E'	 // 経費精算＿出金（法人）_D
const WALLET_TRADING_CLASS_201 = '03F'	 // 給与振込＿入金（個人）
const WALLET_TRADING_CLASS_202 = '03G'	 // 給与振込＿入金（個人）_W
const WALLET_TRADING_CLASS_203 = '03H'	 // 経費精算＿入金（個人）
const WALLET_TRADING_CLASS_204 = '03I'	 // 経費精算＿入金（個人）_W
const WALLET_TRADING_CLASS_205 = '0H1'	 // SO連携送金出金(個人)
const WALLET_TRADING_CLASS_206 = '0H2'	 // SO連携送金出金(個人)_W
const WALLET_TRADING_CLASS_207 = '0H3'	 // SO連携送金出金(個人)_C
const WALLET_TRADING_CLASS_208 = '0H4'	 // SO連携送金入金(法人)
const WALLET_TRADING_CLASS_209 = '0H5'	 // SO連携送金入金(法人)_W
const WALLET_TRADING_CLASS_210 = '0H6'	 // SO連携送金入金(法人)_C
const WALLET_TRADING_CLASS_211 = '03J'	 // 預り金送金_入金(個人)
const WALLET_TRADING_CLASS_212 = '03K'	 // 預り金送金_入金(個人)_W
const WALLET_TRADING_CLASS_213 = '07F'	 // 預り金送金_出金(法人)
const WALLET_TRADING_CLASS_214 = '07G'	 // 預り金送金_出金(法人)_D
const WALLET_TRADING_CLASS_215 = '05F'	 // 銀行口座振込出金（手数料無料）
const WALLET_TRADING_CLASS_216 = '05G'	 // 銀行口座限度額超え出金（手数料無料）
const WALLET_TRADING_CLASS_217 = '0D8'	 // 銀行ATM払出＿出金（手数料無料）
const WALLET_TRADING_CLASS_218 = '0D9'	 // 銀行ATM限度額超え出金（手数料無料）
const WALLET_TRADING_CLASS_219 = '0WV'	 // 送金原資入金（法人）_D
const WALLET_TRADING_CLASS_220 = '0WW'	 // オートチャージ＿入金_D
const WALLET_TRADING_CLASS_221 = '0WX'	 // オートチャージ＿入金_W
const WALLET_TRADING_CLASS_222 = '0GR'	 // オートチャージ＿入金_C
const WALLET_TRADING_CLASS_223 = '07H'	 // 別用途＿出金（法人）
const WALLET_TRADING_CLASS_224 = '07I'	 // 別用途＿出金（法人）_D
const WALLET_TRADING_CLASS_225 = '03L'	 // 別用途＿入金（個人）
const WALLET_TRADING_CLASS_226 = '03M'	 // 別用途＿入金（個人）_W
const WALLET_TRADING_CLASS_227 = '05H'	 // 送金原資返金出金
const WALLET_TRADING_CLASS_228 = '0H7'	 // 回線不備出金（個人）
const WALLET_TRADING_CLASS_229 = '0H8'	 // 回線不備出金（個人）_W
const WALLET_TRADING_CLASS_230 = '0H9'	 // 回線不備出金（個人）_C
const WALLET_TRADING_CLASS_231 = '0G3'	// 口座引落しＢＰ＿入金_C
const WALLET_TRADING_CLASS_232 = '0GS'	// オートチャージＢＰ＿入金_C
const WALLET_TRADING_CLASS_233 = '0J0'	// 口座引落しＢＰ＿入金_D
const WALLET_TRADING_CLASS_234 = '0J1'	// 口座引落しＢＰ＿入金_W
const WALLET_TRADING_CLASS_235 = '0J2'	// オートチャージＢＰ＿入金_D
const WALLET_TRADING_CLASS_236 = '0J3'	// オートチャージＢＰ＿入金_W
const WALLET_TRADING_CLASS_237 = '0J4'	// 不足額月初チャージBS_D
const WALLET_TRADING_CLASS_238 = '0J5'	// 不足額月初チャージBS_W
const WALLET_TRADING_CLASS_239 = '0GT'	// 不足額月初チャージBS_C
const WALLET_TRADING_CLASS_240 = '0J6'	// 不足額加盟店チャージBS_D
const WALLET_TRADING_CLASS_241 = '0J7'	// 不足額加盟店チャージBS_W
const WALLET_TRADING_CLASS_242 = '0GU'	// 不足額加盟店チャージBS_C
const WALLET_TRADING_CLASS_243 = '0J8'	// 不足額月初チャージBP_D
const WALLET_TRADING_CLASS_244 = '0J9'	// 不足額月初チャージBP_W
const WALLET_TRADING_CLASS_245 = '0GV'	// 不足額月初チャージBP_C
const WALLET_TRADING_CLASS_246 = '0JA'	// 不足額加盟店チャージBP_D
const WALLET_TRADING_CLASS_247 = '0JB'	// 不足額加盟店チャージBP_W
const WALLET_TRADING_CLASS_248 = '0GW'	// 不足額加盟店チャージBP_C
const WALLET_TRADING_CLASS_249 = '05L'	// 請求支払出金
const WALLET_TRADING_CLASS_250 = '01E'	// 請求支払入金
const WALLET_TRADING_CLASS_251 = '05J'	// ペイロール振込出金
const WALLET_TRADING_CLASS_252 = '05K'	// ペイロール振込出金（手数料無料）
const WALLET_TRADING_CLASS_253 = '01D'	// ペイロール振込不能入金
const WALLET_TRADING_CLASS_254 = '136'	// ペイロール振込出金手数料
const WALLET_TRADING_CLASS_255 = '0EI'	// ｄ投資預入_出金（法人）
const WALLET_TRADING_CLASS_256 = '0EJ'	// ｄ投資預入_入金（個人）
const WALLET_TRADING_CLASS_257 = '0EK'	// ｄ投資払出_出金（個人）
const WALLET_TRADING_CLASS_258 = '0EL'	// ｄ投資払出_入金（法人）
const WALLET_TRADING_CLASS_259 = '0EM'	// ｄ投資預入_出金（法人）D
const WALLET_TRADING_CLASS_260 = '0EN'	// ｄ投資預入_入金（個人）W
const WALLET_TRADING_CLASS_261 = '05M'	// 銀行口座振込出金（全ユーザ無料）
const WALLET_TRADING_CLASS_262 = '05N'	// 銀行口座限度額超え出金（全ユーザ無料）
const WALLET_TRADING_CLASS_263 = '0DA'	// 銀行ATM払出＿出金（全ユーザ無料）
const WALLET_TRADING_CLASS_264 = '0DB'	// 銀行ATM限度額超え出金（全ユーザ無料）
const WALLET_TRADING_CLASS_265 = '05P'	// ペイロール振込出金（全ユーザ無料）
const WALLET_TRADING_CLASS_266 = '0HA'	// 回線不備入金(法人)
const WALLET_TRADING_CLASS_267 = '0HB'	// 回線不備入金(法人)_W
const WALLET_TRADING_CLASS_268 = '0HC'	// 回線不備入金(法人)_C

// オーダー種別
const ORDER_TYPE_MODEL_CHANGE = '01'         // 機種変更
const ORDER_TYPE_ACCESSORY = '02'            // 付属品購入
const ORDER_TYPE_DEVICE_AND_ACCESSORY = '03' // 移動機＋付属品

// アカウントステータス
const ACCOUNT_STATUS_ENABLED = '01'      // 有効（本登録済み）
const ACCOUNT_STATUS_LOCK = '02'  // アカウントロック中
const ACCOUNT_STATUS_PW_EXPIRED = '03'  // パスワード期限切れ
const ACCOUNT_STATUS_LOCK_EXPIRED = '04'  // ロック中/パスワード期限切れ

// エンドユーザー向けメールテンプレート種別
const ENDUSER_MAIL_TEMPLATE_DEFAULT = '01'      // 既存テンプレート
const ENDUSER_MAIL_TEMPLATE_CUSTOM = '02'  // 既存テンプレートをカスタム
const ENDUSER_MAIL_TEMPLATE_NONE = '03'  // テンプレート作成（白紙）
const ENDUSER_MAIL_TEMPLATE_EDIT = '04'  // テンプレート再編集

// コンテンツデータ編集対象ファイル名
const CONTENTSDATA_TOP_NOTICE = 'notification' // TOP画面_お知らせ
const CONTENTSDATA_TOP_CAUTION = 'TopCaution1' // TOP画面_注意事項
const CONTENTSDATA_CONFIRM_COMMENT = 'userinfo_comment' // 各種情報内容確認画面_コメントの編集
const CONTENTSDATA_SELECT_COMMENT = 'selectionCaution' // サービス選択画面_コメントの編集
const CONTENTSDATA_SETTLE_DPAY = 'service_comment_dcm' // サービス履歴_d払い等決済サービス
const CONTENTSDATA_SETTLE_WALLET = 'service_comment_wallet' // サービス履歴_ウォレット機能
const CONTENTSDATA_SETTLE_ONLINE_AHAMO = 'service_comment_online' // サービス履歴_オンラインショップ・ahamo
const CONTENTSDATA_LOSTINFO_COMMENT = 'lostinfo_comment' // 紛失/盗難情報入力画面_コメントの編集
const CONTENTSDATA_CONFIRM_POPUP_COMMENT = 'confirm_comment' // 最終確認画面_コメントの編集
const CONTENTSDATA_CHECK_OTHER_SERVISE_COMMENT = 'checkservices_comment' // 他サービス有無選択画面_コメントの編集
const CONTENTSDATA_SELECT_MODEL_NAME = "model_name_list" // コンシューマー画面_機種名の編集
const CONTENTSDATA_AGENCY_TOP_CAUTION = 'agencyInputCaution' // 代行者画面_TOP画面_注意事項
const CONTENTSDATA_AGENCY_SETTLE_DPAY = 'agency_service_comment_dcm' // 代行者画面_サービス履歴_d払い等決済サービス
const CONTENTSDATA_AGENCY_SETTLE_WALLET = 'agency_service_comment_wallet' // 代行者画面_サービス履歴_ウォレット機能
const CONTENTSDATA_AGENCY_SETTLE_ONLINE_AHAMO = 'agency_service_comment_online' // 代行者画面_サービス履歴_オンラインショップ・ahamo
const CONTENTSDATA_AGENCY_LOSTINFO_COMMENT = 'agency_lostinfo_comment' // 代行者画面_紛失/盗難情報入力画面_コメントの編集
const CONTENTSDATA_AGENCY_CONFIRM_POPUP_COMMENT = 'agency_confirm_comment' // 代行者画面_最終確認画面_コメントの編集
const CONTENTSDATA_AGENCY_CHECK_OTHER_SERVISE_COMMENT = 'agency_checkservices_comment' // 代行者画面_他サービス有無選択画面_コメントの編集
const CONTENTSDATA_AGENCY_SELECT_MODEL_NAME = "agency_model_name_list" // 代行者画面_機種名の編集

// コンテンツデータ取得用 対象S3種別
const S3TYPE_CONSUMER = '0' // consumer画面
const S3TYPE_OPERATOR = '1' // operator画面
const S3TYPE_NOTICE = '2'   // お知らせ文言

// 解約契機フラグ
const CANCEL_FLAG_OFF = '00'
const CANCEL_FLAG_ON = '01'

// 予期しないエラーの文言
const ERROR_SENTENCE_DCMPAY_WALLET = 'ご迷惑をおかけしており申し訳ありません。<br>現在、システムに問題が発生しており、身に覚えのないご利用のお問い合わせのご利用ができません。<br>復旧まで今しばらくお待ちください。<br><br>なお、復旧までの間のお問い合わせは、お電話またはドコモショップにて受付しております。<br><br>【d払いお問い合わせダイヤル】<br>■ドコモの携帯電話から<br>＃9785（無料）<br>※一般電話などからはご利用になれません。<br><br>■一般電話などから\n0570-018-360（有料）<br>※一部のIP電話からは接続できない場合があります。<br>受付時間：24時間・年中無休<br>※但し、午後6時～午前10時については、ドコモと回線契約しているお客さまの「利用停止」のみの受付となります。'      // d払い等決済サービス or ウォレット機能
const ERROR_SENTENCE_ONLINESHOP_AHAMO = 'ご迷惑をおかけしており申し訳ありません。<br>現在、システムに問題が発生しており、身に覚えのないご利用のお問い合わせのご利用ができません。<br>復旧まで今しばらくお待ちください。<br><br>なお、復旧までの間のお問い合わせは、お電話にて受付しております。<br><br>【ドコモオンラインショップセンター】<br>■ドコモの携帯電話から<br>＃8067（無料）<br>※ガイダンスが流れたら「3」を押下してください。<br>※一般電話などからはご利用になれません。<br><br>■一般電話などから<br>0120-138-067（無料）<br>※ガイダンスが流れたら「3」を押下してください。<br>※一部のIP電話からは接続できない場合があります。<br>受付時間：午前9時～午後8時・年中無休'      // オンラインショップ or ahamo

export default {
    // サービス種別
    SERVICE_TYPE_ALL,
    SERVICE_TYPE_DCMPAY,
    SERVICE_TYPE_WALLET,
    SERVICE_TYPE_ONLINESHOP,
    SERVICE_TYPE_AHAMO,
    SERVICE_TYPE_DCMPAY_TOUCH,
    SERVICE_TYPE_DCMPAY_GIFT,
    // ログインユーザ権限
    USER_AUTHORITY_ADMIN,
    USER_AUTHORITY_OPERATOR,
    USER_AUTHORITY_AGENCY,
    // 一覧種別
    LISTTYPE_ENQUIRY,
    LISTTYPE_SETTLEMENT,
    // メインステータス
    STATUS_NEWENTRY,
    STATUS_WS_PROGRESS,
    STATUS_SD_REQUEST,
    STATUS_SD_PROGRESS,
    STATUS_SD_COMPLETE,
    STATUS_REPAIR_JUDGE,
    STATUS_REPAIR_OK,
    STATUS_REPAIR_NG,
    STATUS_REPAIR_MIX,
    STATUS_COMPLETE_DOC,
    STATUS_COMPLETE_TEL,
    STATUS_CORRECTION_POINT,
    STATUS_CORRECTION_AMOUNT,
    STATUS_CORRECTION_CC_CANCEL,
    STATUS_CORRECTION_COMPLETE,
    STATUS_INVESTIGATION_WITHDRAWN,
    STATUS_DECLARATION,
    STATUS_DECLARATION_RECEIPT,
    STATUS_CORRECTION_MIXTURE,
    STATUS_COMPLETE_OK,
    STATUS_COMPLETE_NG,
    STATUS_PREVIOUS,
    STATUS_TEST,
    STATUS_NO_INVESTIGATION,
    STATUS_REQUIRE_DATA_EXTRACTION,
    STATUS_CORRECTION_PLAN,
    // サブステータス
    SUBSTATUS_NONE,
    SUBSTATUS_PHISHING,
    SUBSTATUS_LIST_ATTACK,
    SUBSTATUS_MALWARE,
    SUBSTATUS_DISCARDED_ACCOUNTS,
    SUBSTATUS_HIJACKING_MAILACCOUNTS,
    SUBSTATUS_CANCEL_INVEST,
    SUBSTATUS_CANNOT_JUDGE,
    SUBSTATUS_CANNOT_INVEST,
    SUBSTATUS_THIRD_PARTY_ACCESS_FOREIGNERS,
    SUBSTATUS_THIRD_PARTY_ACCESS,
    SUBSTATUS_PERSONALUSE,
    SUBSTATUS_PARTIAL_PERSONALUSE,
    // 支払方法
    SETTLEMENT_MEANS_TOTALING,
    SETTLEMENT_MEANS_DCMWALLET,
    SETTLEMENT_MEANS_CREDIT,
    SETTLEMENT_MEANS_DCARD,
    SETTLEMENT_MEANS_CONVENIENCE,
    SETTLEMENT_MEANS_CASHON,
    // 課金種別
    BILLING_METHOD_EACHTIME,
    BILLING_METHOD_PERIODICALLY,
    BILLING_METHOD_ANYTIME,
    // メール承認ステータス
    ENDUSER_MAIL_STATUS_NONE,
    ENDUSER_MAIL_STATUS_APPROVAL_WAIT,
    ENDUSER_MAIL_STATUS_APPROVED,
    // メール送信ステータス
    ENDUSER_MAIL_SEND_STATUS_DEFAULT,
    ENDUSER_MAIL_SEND_STATUS_ENQUIRY_SEND_SUCCESS,
    ENDUSER_MAIL_SEND_STATUS_ENQUIRY_SEND_ERROR,
    ENDUSER_MAIL_SEND_STATUS_ENQUIRY_SEND_RETRY,
    ENDUSER_MAIL_SEND_STATUS_COMPLETE_SEND_SUCCESS,
    ENDUSER_MAIL_SEND_STATUS_COMPLETE_SEND_ERROR,
    ENDUSER_MAIL_SEND_STATUS_COMPLETE_SEND_RETRY,
    ENDUSER_MAIL_SEND_STATUS_COMPLETE_CANCEL_SUCCESS,
    ENDUSER_MAIL_SEND_STATUS_COMPLETE_CANCEL_ERROR,
    ENDUSER_MAIL_SEND_STATUS_COMPLETE_CANCEL_RETRY,
    // 取引区分(WALLET)
    WALLET_TRADING_CLASS_001,
    WALLET_TRADING_CLASS_002,
    WALLET_TRADING_CLASS_003,
    WALLET_TRADING_CLASS_004,
    WALLET_TRADING_CLASS_005,
    WALLET_TRADING_CLASS_006,
    WALLET_TRADING_CLASS_007,
    WALLET_TRADING_CLASS_008,
    WALLET_TRADING_CLASS_009,
    WALLET_TRADING_CLASS_010,
    WALLET_TRADING_CLASS_011,
    WALLET_TRADING_CLASS_012,
    WALLET_TRADING_CLASS_013,
    WALLET_TRADING_CLASS_014,
    WALLET_TRADING_CLASS_015,
    WALLET_TRADING_CLASS_016,
    WALLET_TRADING_CLASS_017,
    WALLET_TRADING_CLASS_018,
    WALLET_TRADING_CLASS_019,
    WALLET_TRADING_CLASS_020,
    WALLET_TRADING_CLASS_021,
    WALLET_TRADING_CLASS_022,
    WALLET_TRADING_CLASS_023,
    WALLET_TRADING_CLASS_024,
    WALLET_TRADING_CLASS_025,
    WALLET_TRADING_CLASS_026,
    WALLET_TRADING_CLASS_027,
    WALLET_TRADING_CLASS_028,
    WALLET_TRADING_CLASS_029,
    WALLET_TRADING_CLASS_030,
    WALLET_TRADING_CLASS_031,
    WALLET_TRADING_CLASS_032,
    WALLET_TRADING_CLASS_033,
    WALLET_TRADING_CLASS_034,
    WALLET_TRADING_CLASS_035,
    WALLET_TRADING_CLASS_036,
    WALLET_TRADING_CLASS_037,
    WALLET_TRADING_CLASS_038,
    WALLET_TRADING_CLASS_039,
    WALLET_TRADING_CLASS_040,
    WALLET_TRADING_CLASS_041,
    WALLET_TRADING_CLASS_042,
    WALLET_TRADING_CLASS_043,
    WALLET_TRADING_CLASS_044,
    WALLET_TRADING_CLASS_045,
    WALLET_TRADING_CLASS_046,
    WALLET_TRADING_CLASS_047,
    WALLET_TRADING_CLASS_048,
    WALLET_TRADING_CLASS_049,
    WALLET_TRADING_CLASS_050,
    WALLET_TRADING_CLASS_051,
    WALLET_TRADING_CLASS_052,
    WALLET_TRADING_CLASS_053,
    WALLET_TRADING_CLASS_054,
    WALLET_TRADING_CLASS_055,
    WALLET_TRADING_CLASS_056,
    WALLET_TRADING_CLASS_057,
    WALLET_TRADING_CLASS_058,
    WALLET_TRADING_CLASS_059,
    WALLET_TRADING_CLASS_060,
    WALLET_TRADING_CLASS_061,
    WALLET_TRADING_CLASS_062,
    WALLET_TRADING_CLASS_063,
    WALLET_TRADING_CLASS_064,
    WALLET_TRADING_CLASS_065,
    WALLET_TRADING_CLASS_066,
    WALLET_TRADING_CLASS_067,
    WALLET_TRADING_CLASS_068,
    WALLET_TRADING_CLASS_069,
    WALLET_TRADING_CLASS_070,
    WALLET_TRADING_CLASS_071,
    WALLET_TRADING_CLASS_072,
    WALLET_TRADING_CLASS_073,
    WALLET_TRADING_CLASS_074,
    WALLET_TRADING_CLASS_075,
    WALLET_TRADING_CLASS_076,
    WALLET_TRADING_CLASS_077,
    WALLET_TRADING_CLASS_078,
    WALLET_TRADING_CLASS_079,
    WALLET_TRADING_CLASS_080,
    WALLET_TRADING_CLASS_081,
    WALLET_TRADING_CLASS_082,
    WALLET_TRADING_CLASS_083,
    WALLET_TRADING_CLASS_084,
    WALLET_TRADING_CLASS_085,
    WALLET_TRADING_CLASS_086,
    WALLET_TRADING_CLASS_087,
    WALLET_TRADING_CLASS_088,
    WALLET_TRADING_CLASS_089,
    WALLET_TRADING_CLASS_090,
    WALLET_TRADING_CLASS_091,
    WALLET_TRADING_CLASS_092,
    WALLET_TRADING_CLASS_093,
    WALLET_TRADING_CLASS_094,
    WALLET_TRADING_CLASS_095,
    WALLET_TRADING_CLASS_096,
    WALLET_TRADING_CLASS_097,
    WALLET_TRADING_CLASS_098,
    WALLET_TRADING_CLASS_099,
    WALLET_TRADING_CLASS_100,
    WALLET_TRADING_CLASS_101,
    WALLET_TRADING_CLASS_102,
    WALLET_TRADING_CLASS_103,
    WALLET_TRADING_CLASS_104,
    WALLET_TRADING_CLASS_105,
    WALLET_TRADING_CLASS_106,
    WALLET_TRADING_CLASS_107,
    WALLET_TRADING_CLASS_108,
    WALLET_TRADING_CLASS_109,
    WALLET_TRADING_CLASS_110,
    WALLET_TRADING_CLASS_111,
    WALLET_TRADING_CLASS_112,
    WALLET_TRADING_CLASS_113,
    WALLET_TRADING_CLASS_114,
    WALLET_TRADING_CLASS_115,
    WALLET_TRADING_CLASS_116,
    WALLET_TRADING_CLASS_117,
    WALLET_TRADING_CLASS_118,
    WALLET_TRADING_CLASS_119,
    WALLET_TRADING_CLASS_120,
    WALLET_TRADING_CLASS_121,
    WALLET_TRADING_CLASS_122,
    WALLET_TRADING_CLASS_123,
    WALLET_TRADING_CLASS_124,
    WALLET_TRADING_CLASS_125,
    WALLET_TRADING_CLASS_126,
    WALLET_TRADING_CLASS_127,
    WALLET_TRADING_CLASS_128,
    WALLET_TRADING_CLASS_129,
    WALLET_TRADING_CLASS_130,
    WALLET_TRADING_CLASS_131,
    WALLET_TRADING_CLASS_132,
    WALLET_TRADING_CLASS_133,
    WALLET_TRADING_CLASS_134,
    WALLET_TRADING_CLASS_135,
    WALLET_TRADING_CLASS_136,
    WALLET_TRADING_CLASS_137,
    WALLET_TRADING_CLASS_138,
    WALLET_TRADING_CLASS_139,
    WALLET_TRADING_CLASS_140,
    WALLET_TRADING_CLASS_141,
    WALLET_TRADING_CLASS_142,
    WALLET_TRADING_CLASS_143,
    WALLET_TRADING_CLASS_144,
    WALLET_TRADING_CLASS_145,
    WALLET_TRADING_CLASS_146,
    WALLET_TRADING_CLASS_147,
    WALLET_TRADING_CLASS_148,
    WALLET_TRADING_CLASS_149,
    WALLET_TRADING_CLASS_150,
    WALLET_TRADING_CLASS_151,
    WALLET_TRADING_CLASS_152,
    WALLET_TRADING_CLASS_153,
    WALLET_TRADING_CLASS_154,
    WALLET_TRADING_CLASS_155,
    WALLET_TRADING_CLASS_156,
    WALLET_TRADING_CLASS_157,
    WALLET_TRADING_CLASS_158,
    WALLET_TRADING_CLASS_159,
    WALLET_TRADING_CLASS_160,
    WALLET_TRADING_CLASS_161,
    WALLET_TRADING_CLASS_162,
    WALLET_TRADING_CLASS_163,
    WALLET_TRADING_CLASS_164,
    WALLET_TRADING_CLASS_165,
    WALLET_TRADING_CLASS_166,
    WALLET_TRADING_CLASS_167,
    WALLET_TRADING_CLASS_168,
    WALLET_TRADING_CLASS_169,
    WALLET_TRADING_CLASS_170,
    WALLET_TRADING_CLASS_171,
    WALLET_TRADING_CLASS_172,
    WALLET_TRADING_CLASS_173,
    WALLET_TRADING_CLASS_174,
    WALLET_TRADING_CLASS_175,
    WALLET_TRADING_CLASS_176,
    WALLET_TRADING_CLASS_177,
    WALLET_TRADING_CLASS_178,
    WALLET_TRADING_CLASS_179,
    WALLET_TRADING_CLASS_180,
    WALLET_TRADING_CLASS_181,
    WALLET_TRADING_CLASS_182,
    WALLET_TRADING_CLASS_183,
    WALLET_TRADING_CLASS_184,
    WALLET_TRADING_CLASS_185,
    WALLET_TRADING_CLASS_186,
    WALLET_TRADING_CLASS_187,
    WALLET_TRADING_CLASS_188,
    WALLET_TRADING_CLASS_189,
    WALLET_TRADING_CLASS_190,
    WALLET_TRADING_CLASS_191,
    WALLET_TRADING_CLASS_192,
    WALLET_TRADING_CLASS_193,
    WALLET_TRADING_CLASS_194,
    WALLET_TRADING_CLASS_195,
    WALLET_TRADING_CLASS_196,
    WALLET_TRADING_CLASS_197,
    WALLET_TRADING_CLASS_198,
    WALLET_TRADING_CLASS_199,
    WALLET_TRADING_CLASS_200,
    WALLET_TRADING_CLASS_201,
    WALLET_TRADING_CLASS_202,
    WALLET_TRADING_CLASS_203,
    WALLET_TRADING_CLASS_204,
    WALLET_TRADING_CLASS_205,
    WALLET_TRADING_CLASS_206,
    WALLET_TRADING_CLASS_207,
    WALLET_TRADING_CLASS_208,
    WALLET_TRADING_CLASS_209,
    WALLET_TRADING_CLASS_210,
    WALLET_TRADING_CLASS_211,
    WALLET_TRADING_CLASS_212,
    WALLET_TRADING_CLASS_213,
    WALLET_TRADING_CLASS_214,
    WALLET_TRADING_CLASS_215,
    WALLET_TRADING_CLASS_216,
    WALLET_TRADING_CLASS_217,
    WALLET_TRADING_CLASS_218,
    WALLET_TRADING_CLASS_219,
    WALLET_TRADING_CLASS_220,
    WALLET_TRADING_CLASS_221,
    WALLET_TRADING_CLASS_222,
    WALLET_TRADING_CLASS_223,
    WALLET_TRADING_CLASS_224,
    WALLET_TRADING_CLASS_225,
    WALLET_TRADING_CLASS_226,
    WALLET_TRADING_CLASS_227,
    WALLET_TRADING_CLASS_228,
    WALLET_TRADING_CLASS_229,
    WALLET_TRADING_CLASS_230,
    WALLET_TRADING_CLASS_231,
    WALLET_TRADING_CLASS_232,
    WALLET_TRADING_CLASS_233,
    WALLET_TRADING_CLASS_234,
    WALLET_TRADING_CLASS_235,
    WALLET_TRADING_CLASS_236,
    WALLET_TRADING_CLASS_237,
    WALLET_TRADING_CLASS_238,
    WALLET_TRADING_CLASS_239,
    WALLET_TRADING_CLASS_240,
    WALLET_TRADING_CLASS_241,
    WALLET_TRADING_CLASS_242,
    WALLET_TRADING_CLASS_243,
    WALLET_TRADING_CLASS_244,
    WALLET_TRADING_CLASS_245,
    WALLET_TRADING_CLASS_246,
    WALLET_TRADING_CLASS_247,
    WALLET_TRADING_CLASS_248,
    WALLET_TRADING_CLASS_249,
    WALLET_TRADING_CLASS_250,
    WALLET_TRADING_CLASS_251,
    WALLET_TRADING_CLASS_252,
    WALLET_TRADING_CLASS_253,
    WALLET_TRADING_CLASS_254,
    WALLET_TRADING_CLASS_255,
    WALLET_TRADING_CLASS_256,
    WALLET_TRADING_CLASS_257,
    WALLET_TRADING_CLASS_258,
    WALLET_TRADING_CLASS_259,
    WALLET_TRADING_CLASS_260,
    WALLET_TRADING_CLASS_261,
    WALLET_TRADING_CLASS_262,
    WALLET_TRADING_CLASS_263,
    WALLET_TRADING_CLASS_264,
    WALLET_TRADING_CLASS_265,
    WALLET_TRADING_CLASS_266,
    WALLET_TRADING_CLASS_267,
    WALLET_TRADING_CLASS_268,
    // オーダー種別
    ORDER_TYPE_MODEL_CHANGE,
    ORDER_TYPE_ACCESSORY,
    ORDER_TYPE_DEVICE_AND_ACCESSORY,
    // アカウントステータス
    ACCOUNT_STATUS_ENABLED,
    ACCOUNT_STATUS_LOCK,
    ACCOUNT_STATUS_PW_EXPIRED,
    ACCOUNT_STATUS_LOCK_EXPIRED,
    // エンドユーザー向けメールテンプレート種別
    ENDUSER_MAIL_TEMPLATE_DEFAULT,
    ENDUSER_MAIL_TEMPLATE_CUSTOM,
    ENDUSER_MAIL_TEMPLATE_NONE,
    ENDUSER_MAIL_TEMPLATE_EDIT,
    // コンテンツデータ編集対象ファイル名
    CONTENTSDATA_TOP_NOTICE,
    CONTENTSDATA_TOP_CAUTION,
    CONTENTSDATA_CONFIRM_COMMENT,
    CONTENTSDATA_SELECT_COMMENT,
    CONTENTSDATA_SETTLE_DPAY,
    CONTENTSDATA_SETTLE_WALLET,
    CONTENTSDATA_SETTLE_ONLINE_AHAMO,
    CONTENTSDATA_LOSTINFO_COMMENT,
    CONTENTSDATA_CONFIRM_POPUP_COMMENT,
    CONTENTSDATA_CHECK_OTHER_SERVISE_COMMENT,
    CONTENTSDATA_SELECT_MODEL_NAME,
    CONTENTSDATA_AGENCY_TOP_CAUTION,
    CONTENTSDATA_AGENCY_SETTLE_DPAY,
    CONTENTSDATA_AGENCY_SETTLE_WALLET,
    CONTENTSDATA_AGENCY_SETTLE_ONLINE_AHAMO,
    CONTENTSDATA_AGENCY_LOSTINFO_COMMENT,
    CONTENTSDATA_AGENCY_CONFIRM_POPUP_COMMENT,
    CONTENTSDATA_AGENCY_CHECK_OTHER_SERVISE_COMMENT,
    CONTENTSDATA_AGENCY_SELECT_MODEL_NAME,
    // コンテンツデータ取得用 対象S3種別
    S3TYPE_CONSUMER,
    S3TYPE_OPERATOR,
    S3TYPE_NOTICE,
    // 解約契機フラグ
    CANCEL_FLAG_OFF,
    CANCEL_FLAG_ON,
    // 予期しないエラーの文言
    ERROR_SENTENCE_DCMPAY_WALLET,
    ERROR_SENTENCE_ONLINESHOP_AHAMO
}
